<template>
  <div class="container-fluid">
    <!-- <nav
      class="navbar navbar-dark navbar-expand-lg"
      style="
        background-color: white;
        font-size: 0.9rem;
        color: black;
        vertical-align: bottom;
      "
    >
     
      <div class="container-fluid">
        <a class="navbar-brand" href="#">
          <img @click="gotolanding" src="@/assets/images/cts_logo_hzl-wo_bg.png" height="50px" />
       
        </a>
        <button
          class="navbar-toggler active"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#loginNavbar"
          aria-controls="loginNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="loginNavbar">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link" aria-current="page" href="#/dashboard"
                >Home</a
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" href="#/attendance" to="/attendence"
                >Attendance</router-link
              >
            </li>
            <li class="nav-item">
             
              <router-link class="nav-link" :to="{ name: 'payslip' }"
                >Payslips</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" href="#/payslip" to="paysheet"
                >PaySheet</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" href="#/leaves" to="leave-request"
                >Leaves</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                href="#/approve-leaves"
                to="mstr-leave-request"
                >Approve Leaves</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'payroll' }"
                >Payroll</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                href="#/personal-details"
                to="employee-list"
                >Employee</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                href="#/pay-structure"
                to="pay-structure"
                >Pay Structure</router-link
              >
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarMasterDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Master
              </a>
              <ul class="dropdown-menu">
                <li>
                  <router-link
                    class="dropdown-item nav-link"
                    href="#"
                    to="/company"
                    >Company</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="dropdown-item nav-link"
                    href="#"
                    to="/branch"
                    >Branch</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="dropdown-item nav-link"
                    href="#"
                    to="/designation"
                    >Designation</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="dropdown-item nav-link"
                    href="#"
                    to="/salary"
                    >Salary</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="dropdown-item nav-link"
                    href="#"
                    to="/leave"
                    >Leave</router-link
                  >
                </li>
                <li>
                  <a class="dropdown-item nav-link" href="#">Expense Type</a>
                </li>
                <li>
                  <a class="dropdown-item nav-link" href="#">Expense SubType</a>
                </li>
                <li>
                  <router-link
                    class="dropdown-item nav-link"
                    href="#"
                    to="/holiday"
                    >Holiday</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="dropdown-item nav-link"
                    href="#"
                    to="/menu"
                    >Menu</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
          <ul class="navbar-nav d-flex me-5">
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Welcome {{ userName }}
              </a>
              <ul
                class="dropdown dropdown-menu dropdown-menu-end"
                style="font-size: 0.875rem"
              >
                <li>
                  <a class="dropdown-item" href="#/refund"
                    ><i
                      style="font-size: 1rem; color: cornflowerblue"
                      class="bi bi-person-check"
                      >&nbsp;&nbsp;</i
                    >KYC</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="goToMyProfile"
                    ><i
                      style="font-size: 1rem; color: orange"
                      class="bi bi-person-badge"
                      >&nbsp;&nbsp;</i
                    >My Profile</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="#/refund"
                    ><i
                      style="font-size: 1rem; color: cornflowerblue"
                      class="bi bi-three-dots"
                      >&nbsp;&nbsp;</i
                    >Reset Password</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click="logout"
                    ><i
                      style="font-size: 1rem; color: cornflowerblue"
                      class="bi bi-three-dots"
                      >&nbsp;&nbsp;</i
                    >Logout</a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav> -->


    <nav
      class="navbar navbar-dark navbar-expand-lg"
      style="
        background-color: white;
        font-size: 0.9rem;
        color: black;
        vertical-align: bottom;
      "
    >
   
      <div class="container-fluid">
        <a class="navbar-brand" href="#">
          <img @click="gotolanding" src="@/assets/images/cts_logo_hzl-wo_bg.png" height="50px" />
        </a>
        <button
          class="navbar-toggler active"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#loginNavbar"
          aria-controls="loginNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li 
            v-for="(menu, index) in menu" 
            :key="index" 
            class="nav-item" 
            :class="{ 'dropdown': menu.subs.length > 0 }"
          >
            <a 
              class="nav-link" 
              :class="{ 'dropdown-toggle': menu.subs.length > 0 }" 
              href="#" @click.prevent="$router.push(menu.menu_url)" 
              v-bind="menu.subs.length > 0 ? { 'data-bs-toggle': 'dropdown', role: 'button', 'aria-expanded': 'false' } : {}"
            >
              <i :class="menu.menu_icon"></i> {{ menu.menu_name }}
            </a>
            
            <!-- Dropdown for Submenus -->
            <ul v-if="menu.subs.length > 0" class="dropdown-menu">
              <li 
                v-for="(sub, subIndex) in menu.subs" 
                :key="subIndex"
              >
                <a class="dropdown-item" href="#" @click.prevent="$router.push(sub.menu_url)">
                  <i :class="sub.menu_icon"></i> {{ sub.menu_name }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="navbar-nav d-flex me-5">
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Welcome {{ userName }}
              </a>
              <ul
                class="dropdown dropdown-menu dropdown-menu-end"
                style="font-size: 0.875rem"
              >
                <li>
                  <a class="dropdown-item" href="#/refund"
                    ><i
                      style="font-size: 1rem; color: cornflowerblue"
                      class="bi bi-person-check"
                      >&nbsp;&nbsp;</i
                    >KYC</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="goToMyProfile"
                    ><i
                      style="font-size: 1rem; color: orange"
                      class="bi bi-person-badge"
                      >&nbsp;&nbsp;</i
                    >My Profile</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="#/refund"
                    ><i
                      style="font-size: 1rem; color: cornflowerblue"
                      class="bi bi-three-dots"
                      >&nbsp;&nbsp;</i
                    >Reset Password</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click="logout"
                    ><i
                      style="font-size: 1rem; color: cornflowerblue"
                      class="bi bi-three-dots"
                      >&nbsp;&nbsp;</i
                    >Logout</a
                  >
                </li>
              </ul>
            </li>
          </ul>
      </div>
      </div>
    </nav>
   
  </div>
</template>
<script>
export default {
  
  computed: {
    userName(){
      var nme = this.$store.getters.loggedUser;
      return nme.data.user_name;
    },
    menu() {
      var nme = this.$store.getters.loggedUser;
      const menuData = nme.data.menu_data;
      
      // Sort submenu items alphabetically by menu_name
      return menuData.map(menu => ({
        ...menu,
        subs: menu.subs && menu.subs.length > 0 ? menu.subs.sort((a, b) => {
          return a.menu_name.localeCompare(b.menu_name);
        }) : menu.subs
      }));
    },
    unreadCount() {
      return this.$store.getters.unreadNotificationCount;
    },
  },
  methods: {
    gotolanding(){
      this.$router.push("/");
    },
    goToMyProfile() {
      const user = this.$store.getters.loggedUser;
      const employee_id = user?.data?.employee_id;
      if (employee_id) {
        this.$router.push(`/profile-view/${employee_id}`);
      }
    },
    logout() {
      
      this.$store.dispatch("logout");
      this.$router.push("/LoginView");
    },
  },
};
</script>
<style>
nav a {
  font-weight: bold;
  color: #4048df;
}

nav a.router-link-exact-active {
  color: #27cc69;
}

.nav-link {
  color: rgb(56, 17, 184) !important;
}

.nav-link:hover {
  color: red !important;
  font-size: 1rem;
}
</style>
